<template>
  <div class="contact-attempts">
    <p class="ut-font-bold ut-pb-3">Attempts</p>
    <ul v-if="hasAttempted">
      <li class="list" v-for="attempt in contactAttempts" :key="attempt.id">
        {{ formatDate(attempt.createddate) }} - Call attempt recorded
      </li>
    </ul>
    <p v-else>No attempt yet.</p>
  </div>
</template>

<script>

export default {
  name: 'ContactAttempts',
  props: {
    contactAttempts: { required: true },
  },
  computed: {
    hasAttempted() {
      return this.contactAttempts && this.contactAttempts.length > 0;
    }
  },
  methods: {
    formatDate(dateString) {
      return this.$options.filters.formatDate(dateString, 'D MMM YYYY hh:mma');
    },
  },
};
</script>

<style lang="scss" scoped>

ul {
  list-style-image: '@/assets/images/close.svg';
  li {
    color: #4B4B4B;
    font-family: Lato;
    font-size: 14px;
  }
}

</style>
